import type { WithContext, WebSite, SearchAction } from 'schema-dts'
import DEFAULT_META_TAGS from '@/constants/meta'

const searchAction: SearchAction & { 'query-input': ReadonlyArray<string> } = {
  '@type': 'SearchAction',
  name: 'Hotel Search',
  target: {
    '@type': 'EntryPoint',
    urlTemplate:
      'https://www.priceline.com/relax/in/{city}/from/{checkin_date}/to/{checkout_date}/rooms/{number_of_rooms}/adults/{number_of_adults}/children/{children_ages}'
  },
  'query-input': [
    'required name=city',
    'required name=checkin_date',
    'required name=checkout_date',
    'required name=number_of_rooms',
    'required name=number_of_adults',
    'optional name=children_ages'
  ]
} as const

const HotelSchemaMarkup: WithContext<WebSite> = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: 'https://www.priceline.com/hotels',
  name: 'Priceline',
  description: DEFAULT_META_TAGS.description.hotels,
  potentialAction: [searchAction]
} as const

export default HotelSchemaMarkup
